import React from 'react';
import Propagator from '../../Propagator';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

const CREATE_GAME_MUTATION = gql`
	mutation($data: JSON!) {
		createGame(data: $data) {
			id
		}
	}
`;

export default ({ children }) => (
	<Mutation mutation={CREATE_GAME_MUTATION}>
		{createGame => Propagator(children, createGame)}
	</Mutation>
);
